import { useRouter } from 'next/router';
import { parseAsArrayOf, parseAsString, useQueryStates } from 'nuqs';

export type SOSFilingsQueryParams = {
  filingsStates: string[];
};

const defaultQueryParams: SOSFilingsQueryParams = {
  filingsStates: [],
};

const useSOSFilingStatesQueryParams = () => {
  const router = useRouter();
  const [queryParams, setQueryParams] = useQueryStates(
    {
      filings_states: parseAsArrayOf(parseAsString).withDefault(defaultQueryParams.filingsStates),
    },
    { history: 'push', clearOnDefault: true },
  );

  const push = (newQuery: Partial<SOSFilingsQueryParams>) => {
    const updated = { ...values, ...newQuery };
    setQueryParams({
      filings_states: updated.filingsStates ?? defaultQueryParams.filingsStates,
    });
  };

  const values: SOSFilingsQueryParams = {
    filingsStates: queryParams.filings_states,
  };

  const filtersCount = values.filingsStates.length;

  const hasFilters = filtersCount > 0;

  return {
    isReady: router.isReady,
    push,
    filtersCount,
    values,
    hasFilters,
  };
};

export default useSOSFilingStatesQueryParams;
